var React = require('react');

function GalleryNextButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.7717 5.20063c.2366-.23661.2366-.62022 0-.85683L14.9159.488067c-.2366-.236607-.6202-.236607-.8568 0-.2366.236607-.2366.620223 0 .856833l3.4273 3.42732-3.4273 3.42732c-.2366.2366-.2366.62022 0 .85683.2366.2366.6202.2366.8568 0l3.8558-3.85574Zm-.4284-1.03428H.571066v1.21174H18.3433V4.16635Z","fill":"#194550"}));
}

GalleryNextButton.defaultProps = {"fill":"none","viewBox":"0 0 19 10"};

module.exports = GalleryNextButton;

GalleryNextButton.default = GalleryNextButton;
